import React from 'react';


import { useRegister } from '../hooks/useRegister';
import RegisterForm from '../components/RegisterForm';
import TermsModal from '../components/TermsModal';
import LoadingOverlay from '../../common/LoadingOverlay';

const RegisterPage = () => {

    const registerState = useRegister();


    const {
        showWelcomeModal,
        showTermsModal,
        acceptedTerms,
        setAcceptedTerms,
        handleConfirmRegister,
        handleCloseTermsModal,
        loading,
        loadingLogin
    } = registerState;

    return (
        <div className="login-screen">
            {/* Formulario centrado */}
            <div className="register">
                <div className="auth-form-container">


                    <RegisterForm {...registerState} />

                </div>
            </div>

            {/* Modal de Términos y Condiciones */}
            <TermsModal
                isOpen={showTermsModal}
                onClose={handleCloseTermsModal}
                onAccept={handleConfirmRegister}
                accepted={acceptedTerms}
                onToggleAccept={setAcceptedTerms}
                loading={loading}
            />

            {/* Loading Overlay hacia el Inicio de Sesión */}
            <LoadingOverlay show={loadingLogin} message="Cargando inicio de sesión..." />

            {/* Modal de Bienvenida para el Registro */}
            {showWelcomeModal && (
                <div className="welcome-modal-overlay">
                    <div className="welcome-modal-content">
                        <h2>¡Cuenta Creada!</h2>
                        <p>Registro exitoso. Redirigiendo al inicio de sesión...</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RegisterPage;